import { render } from "./vision_mission.vue?vue&type=template&id=1482d5db"
import script from "./vision_mission.vue?vue&type=script&lang=js"
export * from "./vision_mission.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__